<template>
  <div>
    <el-row style="margin-bottom: 24px;border-bottom: 1px solid #ddd;">
      <el-col :span="16" style="vertical-align: middle;">
        <h1>問題回報管理 - {{page_structure['name']}}</h1>
      </el-col>
      <el-col :span="8" style="text-align: right;vertical-align: middle;">
        <el-button icon="el-icon-edit" @click="handle_save_button_click">儲存變更</el-button>
      </el-col>
    </el-row>
    <el-row>
      <EditViewForm 
        :handle_dynamic_form_update="handle_dynamic_form_update"
        :handle_file_upload="() => {}"
        :page_structure="page_structure"
        :preloaded_data="context"
        mode="edit"
        />
    </el-row>
    <LoadingBlock :active="loading"></LoadingBlock>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import PageStructure from '@/views/backstage/structure/system_management_page/issue_report_page/IssueReportPageStructure'
import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'

export default {
    mixins: [breadcrumbMixin],
    components: {
      LoadingBlock,
      EditViewForm,
    },
    data() {
      return {
        loading: false,//TODO: change this to true
        page_structure: [],
        context: {}, 
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/issue-report',
        issue_id: null,
      }
    },
    created: async function () {
      this.init({
        id: this.$route.params.id
      })
    },
    beforeRouteUpdate(to, from, next) {
      this.init({
        id: to.params.id,
      })
      next()
    },
    methods: {
      async init ({id}) {
       // console.log('issue: route type:', this.$route.params.type)
        console.log('ssueReport: route id:', id)

        if (!id) {
          this.backstage_router_push({ path: `/system-management/issue-report` })
          return 
        }

        this.page_structure = PageStructure()
        this.issue_id = id

        await this.get_context()
      },
      async get_context () {

        this.loading = true
        
        axios.get(this.resource_api+'/get', {params: {id:this.issue_id}})
            .then((response) => {
              this.loading = false
              if (response.data.success) {
                this.$set(this, 'context', this.translate_to_display_data(this.page_structure, response.data.payload))
              }
              this.update_breadcrumbs_title(this.context['content'])
            })
            .catch(err => {
                this.loading = false
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', this.ERROR.MSG.general_err_msg)
            })
      },
      handle_save_button_click () {
        if (!this.issue_id) {
          console.log('[ERR] IssueReportEdit: saving with no issue_id')
        }

        let param = this.translate_to_form_data(this.page_structure, this.context)

        param.append('id', this.issue_id);

        let config = { headers:{'Content-Type':'multipart/form-data'} } 
        console.log(param)
        console.log(config)

        axios.post(this.resource_api+'/manager-edit', param, config)
          .then (response => { 
            if (!response.data.success) {
              console.log('save/edit failed, msg='+response.data.message+', reponse=', response)
              this.notify_message(this.ERROR.LEVEL.ERROR, '編輯失敗', "")
              return
            }

            console.log('save/edit succeed, response=', response)
            
            this.notify_message(this.ERROR.LEVEL.SUCCESS, '編輯成功', "")
            this.backstage_router_push({ path: `/system-management/issue-report/` })
          }) 
          .catch(({err}) => { 
            this.notify_message(this.ERROR.LEVEL.ERROR, '編輯失敗', "")
            console.log('save/edit failed, err=', err)
          }) 
      },
      handle_dynamic_form_update (key, form_value) {
        console.log('IssueReportEdit: handle_dynamic_form_update:' + key + ', value:', form_value)

        this.$set(this.context, key, form_value)
      }
    }
  };
</script>